export const selectSortCriteria = (state) => state.sortCriteria;
